<template>
  <div>
    <textarea placeholder="Title (optional)" v-model="compose.title" class="shadow-md  border border-gray-300 rounded-lg focus:outline-none focus:shadow-outline bg-gray-100 h-10 w-full mb-2 appearance-none resize-none p-3"></textarea>
    <textarea placeholder="Your content" v-model="compose.content" class="shadow-md  border border-gray-300 rounded-lg focus:outline-none focus:shadow-outline bg-gray-100 h-32 w-full mb-2 appearance-none resize-none p-3"></textarea>
    <div class="flex justify-end">
      <div class="select-none cursor-pointer shadow-xl rounded-full pr-6 py-2 text-center bg-gray-200 border-gray-500 text-green-900 text-lg pl-6" @click="createPost">
        Submit Post as @{{ AppSate.me.user.username }}
      </div>
    </div>

    <p class=" text-gray-700 mt-6 text-right" v-if="msg">
      {{ msg }}
    </p>
  </div>
</template>

<script>
import * as API from '../../api/api'
const Posts = API.Posts
export default {
  data () {
    return {
      AppSate: API.state,
      msg: '',
      compose: {
        title: '',
        content: ''
      }
    }
  },
  mounted () {
    //
  },
  methods: {
    async createPost () {
      let { title, content } = this.compose
      if (API.state.me && API.state.me.jwt && API.state.me.user && API.state.me.user.username && content) {
        try {
          this.msg = 'Loading....'
          await Posts.createPost({ type: 'text', token: API.state.me.jwt, title, content, date: new Date() })
          // Posts.initFeed({ userID: API.state.me.user._id })
          // console.log(post)

          this.compose = {
            title: '',
            content: ''
          }
          this.msg = 'Successfully Submitted....'
          setTimeout(() => {
            this.$router.push('/app/home')
          }, 500)
        } catch (e) {
          if (e && e.response && e.response.data && e.response.data.error) {
            console.log(e)
            this.msg = e.response.data.error || 'Error...'
          } else {
            console.log(e)
          }
        }
      } else {
        console.log('dont have enough data')
      }
    }
  }
}
</script>

<style>

</style>
